import { useState } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useCurrentPlaybackRate = () => {
    const instance = usePlayerInstance();
    const [playbackRate, setPlaybackRate] = useState<number | undefined>(
        () => instance?.playbackRate
    );

    useInstanceEffect((instance) => instance.onPlaybackRateChange(setPlaybackRate));

    return playbackRate;
};
